import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'
import { IPayload } from '@network/models/global.model'
import {
  IShortLink,
  IPostShortLinkParams,
} from '@network/models/short-link.model'

export class ShortLinksApi {
  constructor(private axios: AxiosService) {}

  postShortLink = async (params: IPostShortLinkParams) => {
    const response = await this.axios.post<IPayload<IShortLink>>(
      Endpoints.postShortLink,
      params,
    )
    return response
  }
}
